// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"4c79a881","215":"1fd99760","233":"08226aae","354":"22ecb80e","416":"e6e717bc","453":"7ae57ccd","684":"13dacf0a","960":"0dcd94a4","994":"56549dbe"}[chunkId] + ".chunk.js";
};